// extracted by mini-css-extract-plugin
module.exports = {"nav-link":"nav-link_nav-link__12EZC"};